module.exports = __webpack_public_path__ + "static/atomico-287ba813cbbe2ae8d4935fde912dab89.ttf";